// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1zjRG","content":"LoadingAlert_content__bn4Zu"};